var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-6',attrs:{"color":_vm.color??'',"elevation":"0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }